var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "action"
  }, [_c('Stats', {
    staticClass: "card top_info"
  }), _c('section', {
    staticClass: "bottom_info"
  }, [_c('RecentBlocks', {
    staticClass: "card recent_blk"
  }), _c('div', {
    staticClass: "transactions"
  }, [_c('RecentTransactions', {
    staticClass: "card recent_tx"
  }), _c('RecentInternalTransactions', {
    staticClass: "card recent_itx"
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }